var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'full-height': _vm.isInstantPages}},[(!_vm.isInstantPages)?_c('router-view'):_vm._e(),_c('InstantPages',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInstantPages),expression:"isInstantPages"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }